import { render, staticRenderFns } from "./google-drive-auth-success.vue?vue&type=template&id=be4f6d44&"
import script from "./google-drive-auth-success.vue?vue&type=script&lang=ts&"
export * from "./google-drive-auth-success.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports